<template>
  <div class="cmPage page flex-v">
    <HeaderNav :topLevel="true" />
    <div class="mainWrap contaiBgSet">
      <ClassList @onCode="getCode" @onDetail="onDetail" v-if="showList" />
      <ClassDetail ref="detailRef" @onCode="getCode" v-show="!showList" @onBack="showList = true" />

      <Dialog :title="qrTitle" :modal="true" width="480px" :visible.sync="codeImg">
        <div class="vfWrap flex-v flex-center">
          <img class="codeImg" :src="codeImg" />
          <p class="alignCenter">
            请老师使用微信扫描此小程序二维码
            <br />与小程序-班级-模块中完成相关的邀请操作
          </p>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { Dialog } from "element-ui";
import ClassList from "./classList.vue";
import ClassDetail from "./classDetail.vue";

export default {
  components: {
    ClassList,
    ClassDetail,
    Dialog,
  },
  created() { },
  data() {
    return {
      codeImg: null,
      showList: true,
      qrTitle: '邀请学生'
    };
  },
  methods: {
    onDetail(id) {
      this.$refs.detailRef.classesId = id;
      this.showList = false;
    },
    async getCode(classesId, isTeacher) {
      this.$loading.show('生成中...');
      const res = await this.$post("/classes/inviteQrCode.json", {
        classesId,
      });
      this.qrTitle = isTeacher ? '邀请老师' : '邀请学生'
      this.codeImg = res.data;
      this.$loading.hide();
    },
  },
};
</script>

<style lang="less" scoped>
.cmPage {
  // background: url(https://llss-file.langsounds.com/app/4be6a1879fb4c80ed4bac2a56d4285bb.png) no-repeat center;
  // background-size: 100% 100%;
  overflow: hidden;

  /deep/.container.hasMenu {
    padding: 20px 80px 80px 200px;
    color: #333333;
    font-size: 16px;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
  }

  /deep/.clBtn {
    width: 160px;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 16px 19px -5px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    font-size: 20px;
    color: #FB7C33;
    cursor: pointer;
    font-weight: bold;

    .iconfont {
      font-size: 18px;
      margin-right: 8px;
      // font-weight: normal;
    }
  }

  /deep/.clLeft {
    text-align: center;
    margin-right: 24px;

    img {
      width: 80px;
      height: 80px;
      margin: 0 auto 10px;
      border-radius: 50%;
      object-fit: contain;
    }

    .clSign {
      color: #ffac00;
      background: rgba(255, 172, 0, 0.1);
    }
  }

  /deep/.clSign {
    flex-shrink: 0;
    font-size: 14px;
    color: #999999;
    padding: 2px 8px;
    border-radius: 4px;
    background: rgba(0, 188, 10, 0.08);
    color: #00bc0a;
    box-sizing: border-box;

    &.AUTH_WAITING {
      color: #ff5c5c;
      background: rgba(255, 92, 92, 0.08);
    }

    &.AUTH_NO {
      color: #999999;
      background: rgba(102, 102, 102, 0.08);
    }

    &.WAITING {
      color: #7b3a0a;
      background: rgba(251, 124, 51, 0.1);
    }

    &.caSign {
      margin-left: 16px;
    }
  }

  .mainWrap {
    height: 100%;
    /deep/.vfWrap {
      width: 430px;
      margin: 0 auto;
    }
  }
}


/deep/.clDish {
  position: absolute;
  right: 0;
  top: 4px;

  .clMenus {
    display: none;
    width: 100px;
    // height: 142px;
    background: #fffcf7;
    box-shadow: 0px 16px 19px -5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    font-size: 14px;
    padding: 10px;
    position: absolute;
    right: -14px;
    top: 20px;
    z-index: 2;
    box-sizing: border-box;

    p {
      height: 40px;

      &:hover {
        color: #FB7C33;
      }

      &:not(:last-child) {
        border-bottom: 1px solid #f0e8da;
      }
    }
  }

  &:hover .clMenus {
    display: block;
  }
}


.codeImg {
  width: 240px;
  margin-bottom: 30px;
}
</style>
